import { compareStringsIgnoreCase, dateUtils } from 'shared_DEPRECATED/utils';

import { SESSION_TIME_INTERVAL } from 'features/participants/config';

export const getParticipantName = (userInfo) =>
  userInfo.fullName || userInfo.email;

export const sortTableByUserName = (rowA, rowB) => {
  const rowATitle = getParticipantName(rowA.original.userInfo);
  const rowBTitle = getParticipantName(rowB.original.userInfo);

  return compareStringsIgnoreCase(rowATitle, rowBTitle);
};

export const sortTableBySprintStartDate = (rowA, rowB) =>
  dateUtils.sortingDiff(
    rowA.original.latestSprint.startDate,
    rowB.original.latestSprint.startDate
  );

export const filterByUserName = (row, _, filterValue) => {
  const searchString = filterValue.trim().toLowerCase();

  const { fullName, email } = row.original.userInfo;

  const userName = fullName?.toLowerCase() || '';
  const userEmail = email.toLowerCase();

  return userName.includes(searchString) || userEmail.includes(searchString);
};

const sortByDate = (dateA, dateB) => {
  return dateUtils.sortingDiff(dateA, dateB);
};

export const sortTableBySessionDate = (rowA, rowB, columnId) => {
  const dateA = rowA.original[columnId]?.startAt;
  const dateB = rowB.original[columnId]?.startAt;

  return sortByDate(dateA, dateB);
};

export const sortTableByMomentumScore = (rowA, rowB, columnId) => {
  const rowAMomentum = rowA.original[columnId] || [];
  const rowBMomentum = rowB.original[columnId] || [];

  const rowAMomentumScore = rowAMomentum.at(-1)?.score;
  const rowBMomentumScore = rowBMomentum.at(-1)?.score;

  return rowAMomentumScore - rowBMomentumScore;
};

export const sortTableByUnreadJournalRecordDateTime = (rowA, rowB) => {
  const dateA = rowA.original.journal.firstUnreadJournalRecordDatetime;
  const dateB = rowB.original.journal.firstUnreadJournalRecordDatetime;

  return sortByDate(dateA, dateB);
};

export const getSessionDateWithDefaultTime = (sessionDate) => {
  const currentDate = dateUtils();
  const remainingMinutes =
    SESSION_TIME_INTERVAL - (currentDate.minute() % SESSION_TIME_INTERVAL);

  const sessionDateWithCurrentTime = dateUtils(sessionDate)
    .set('hour', currentDate.hour())
    .set('minute', currentDate.minute() + remainingMinutes);

  return sessionDateWithCurrentTime.toDate();
};

export const getParticipantsData = ({ participants, participantsChats }) => {
  const participantsChatsMap = participantsChats?.reduce((acc, chat) => {
    chat.members.forEach((member) => {
      acc[member.userId] = chat;
    });

    return acc;
  }, {});

  return participants.map((participant) => {
    const chat = participantsChatsMap[participant.userInfo.userId];

    return {
      ...participant,
      isChatMarkedAsUnread: chat ? chat.markedAsReturnTo : false,
      lastReadMessageId: chat?.lastReadMessageId,
    };
  });
};

export const getParticipantUrl = (userEmail) =>
  `/hde/participants/${userEmail}`;
